module.exports = __webpack_public_path__ + "img/Avatar1@2x.12d18843.png";